<div class="modal-header" data-cy="existingPolicyFoundModal"><div class="r-text-lg heavy text-primary">Existing Policy Found</div></div>
<div class="modal-body px-4 pt-3 pb-3">
    <p>There is already an active policy associated with this email.</p>
    <p>Please log in and make modifications from your account dashboard</p>
</div>
<div class="d-flex justify-content-end px-3 pb-3">
    <button class="btn rounded-pill btn-primary-gradient text-white fw-500" data-cy="existingPolicyModalLogInButton" (click)="logIn()" tabindex="-1"><div class="mx-3">Log In</div></button>
</div>
